import React from "react";
import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { ConfirmMutationModal } from "@repoflow/components/modal-confirm";
import * as Notify from "@repoflow/form-schema/notify";
import { Link } from "react-router-dom";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/blog-post";
import { statusOf, DRAFT, PUBLISHED, CHANGED } from "@common/schema/blog-post/status";

export const VIEW_FIELDS = {
  "/Public/BlogPost": {
    fields: ["title", "slug", "abstract", "tags", "authorId", "date", "status", "publishedAt", "publishedSlug", "createdAt", "updatedAt"],
  },
};

// What the two buttons mean, in the words a confirmation should use.
export const publishWording = (post) => {
  const status = statusOf(post);

  if (status === CHANGED) {
    return {
      label: "Publish changes",
      confirmation: "The page will show this draft as it is now. Its address stays the same unless the slug changed.",
    };
  }

  return {
    label: "Publish",
    confirmation: "The post will be available to visitors and listed on the blog.",
  };
};

const BADGE = {
  [DRAFT]: "badge badge-secondary",
  [PUBLISHED]: "badge badge-success",
  [CHANGED]: "badge badge-warning",
};

export const Sidebar = () => null;
export const Indice = () => null;

export const Content = ({
  match: {
    params: { siteId, postId },
  },
}) => {
  const { values, schema, base } = useSectionContext();
  const status = statusOf(values);
  const wording = publishWording(values);

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <span className={BADGE[status]} data-status={status}>{status}</span>
        </Col>
        <Col>
          <div className="float-right">
            {/* Publish is offered on a draft and on a published post with
                changes; Unpublish whenever there is a page to take down.
                Both confirm, because both change what a visitor sees. */}
            {status !== PUBLISHED && (
              <ConfirmMutationModal
                className="btn btn-success"
                label={wording.label}
                mutation={QueriesQL.publish}
                variables={{ siteId, postId }}
                update={QueriesQL.update()}
                onCompleted={() => Notify.success("Published")}
                confirmation={<p>{wording.confirmation}</p>}
              >
                <p>{wording.confirmation}</p>
              </ConfirmMutationModal>
            )}{" "}
            {status !== DRAFT && (
              <ConfirmMutationModal
                className="btn btn-warning"
                label="Unpublish"
                mutation={QueriesQL.unpublish}
                variables={{ siteId, postId }}
                update={QueriesQL.update()}
                onCompleted={() => Notify.success("Unpublished")}
                confirmation={<p>The page comes down at once. The draft is kept.</p>}
              >
                <p>The page comes down at once. The draft is kept.</p>
              </ConfirmMutationModal>
            )}{" "}
            <Link className="btn btn-primary" to={`${base}/edit`}>
              Edit
            </Link>{" "}
            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            widgets={widgets}
            target={{ $ref: "/Public/BlogPost" }}
            config={VIEW_FIELDS}
          />
        </Col>
      </Row>
    </Container>
  );
};
